//記事のフッターに表示するこの記事につけられたタグ一覧
//MUI V5 完了

import React from 'react'
import { kebabCase } from 'lodash/string';
import { Link } from "gatsby"
import { styled } from '@mui/material/styles';

//MUI V5
import { Paper, Typography, Box, Divider, Chip, Link as Link2 } from '@mui/material'
import { useTheme } from '@mui/material/styles';

//アイコン
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'; //関連記事用
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const TagBox = ({ tags, series, seriesTag }) => {
    const theme = useTheme()
    const StyledChip = styled(Chip)({
        //メモ &&のあとにスペースがあると正しく動かない？
        "&&:hover": {
            backgroundColor: theme.palette.primary.main
        },
        "&&:focus": {
            backgroundColor: theme.palette.primary.main
        }
    })
    return (
        <>

            {/* シリーズ */}

            {series?.length > 0 &&
                < Paper sx={{
                    padding: theme.spacing(1),
                    marginTop: theme.spacing(2)
                }} variant="outlined">
                    <Box ml={1} sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        width: "100%"
                    }}>
                        <ArticleOutlinedIcon />
                        <Typography gutterBottom variant="subtitle1"
                            sx={{
                                margin: theme.spacing(1),
                                marginRight: theme.spacing(1)
                            }}>
                            このシリーズの記事一覧
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{
                        "& a": {
                            color: "white",
                            "&:hover": {
                                color: "#64b5f6",
                            },
                        },
                    }} >
                        <ul>
                            {series.map((s) => (
                                <li key={s.slug}>
                                    <Link2 color="inherit" component={Link} to={s.slug} >
                                        {s.title}
                                    </Link2>
                                </li>
                            ))}
                        </ul>
                        <Box display="flex" justifyContent="flex-end"
                            sx={{ paddingRight: theme.spacing(3) , paddingBottom: theme.spacing(2) }} >
                            <DoubleArrowIcon sx={{ marginRight: theme.spacing(1) }} />
                            <Link to={"/tag/" + kebabCase(seriesTag)}>一覧をサムネイル付きインデックスで見る</Link>
                        </Box>
                    </Box>
                </Paper >
            }

            {/* タグ */}

            {
                tags?.length > 0 &&
                < Paper sx={{
                    padding: theme.spacing(1),
                    marginTop: theme.spacing(2)
                }} variant="outlined">
                    <Box ml={1} sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        width: "100%"
                    }}>
                        <LocalOfferOutlinedIcon />
                        <Typography gutterBottom component="div" variant="subtitle1"
                            sx={{
                                margin: theme.spacing(1),
                                marginRight: theme.spacing(1)
                            }}>
                            この記事のタグ
                        </Typography>
                    </Box>
                    <Divider />
                    <Box mt={1} >
                        {tags.map((tag) =>
                            <StyledChip
                                key={tag}
                                label={tag}
                                sx={{
                                    margin: theme.spacing(0.5),

                                }}
                                variant="outlined"
                                clickable
                                component={Link} to={"/tag/" + kebabCase(tag)}
                            />
                        )}
                    </Box>
                </Paper >
            }
        </>
    )

}

export default TagBox